import { render } from "./Tab.vue?vue&type=template&id=1510a69b"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tab/Tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1510a69b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1510a69b', __exports__)) {
    console.log('reload')
    api.reload('1510a69b', __exports__)
  }
  
  module.hot.accept("./Tab.vue?vue&type=template&id=1510a69b", () => {
    console.log('re-render')
    api.rerender('1510a69b', render)
  })

}


export default __exports__